import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Typography from '@cld/typography';
import { messages } from '../../../../i18n';
import { MediaState } from '../../../../types';
import { Section } from '../../common/Section';
import { Info, MediaContainer, EmptyContainer } from './InsertedMedia.styled';
import { MediaItem } from './MediaItem';

export const InsertedMedia: FC<{ media: MediaState }> = ({ media }) => {
  const { formatMessage } = useIntl();

  return (
    <Section title={formatMessage(messages['demo.section.insertedMedia'])} noPadding highlight>
      <Info text={formatMessage(messages['demo.section.insertedMedia.info'])} />
      {media.length ? (
        <MediaContainer data-test="media-container">
          {media.map((item, index) => (
            <MediaItem item={item} key={`${item.url}-${index}`} index={index} />
          ))}
        </MediaContainer>
      ) : (
        <EmptyContainer data-test="empty-media-container">
          <Typography type="regular" size="xs">
            <FormattedMessage {...messages['demo.section.insertedMedia.emptyContainerInfo']} />
          </Typography>
        </EmptyContainer>
      )}
    </Section>
  );
};
